import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { MapboxAddressInput } from '@/components/MapboxAddressInput';
import { MapPin } from 'lucide-react';

interface LocationSectionProps {
  location: string;
  latitude: number | null;
  longitude: number | null;
  onLocationChange: (location: string, coordinates?: { lat: number; lng: number }) => void;
}

const LocationSection: React.FC<LocationSectionProps> = ({
  location,
  latitude,
  longitude,
  onLocationChange,
}) => {
  // Handle text changes from the input
  const handleAddressChange = (value: string) => {
    // Update location text without coordinates when user is typing
    onLocationChange(value);
  };

  // Handle address selection from dropdown
  const handleAddressSelect = (addressData: any) => {
    // Update both location and coordinates when user selects from dropdown
    if (addressData) {
      onLocationChange(addressData.fullAddress, {
        lat: addressData.latitude,
        lng: addressData.longitude
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="h-5 w-5" />
          Location
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="location">Address *</Label>
          <MapboxAddressInput
            value={location}
            onChange={handleAddressChange}
            onAddressSelect={handleAddressSelect}
            placeholder="Enter your display address"
            className="mt-1"
          />
          {latitude && longitude && (
            <p className="text-sm text-muted-foreground mt-2">
              Coordinates: {latitude.toFixed(6)}, {longitude.toFixed(6)}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default LocationSection;